import axios, {AxiosResponse, AxiosRequestConfig} from 'axios'
import qs from 'qs'
import {MAINHOST, ISMOCK, commonPrams} from '@/config'
import requestConfig from '@/config/requestConfig'
import {getToken} from '@/util/common'
import router from '@/router'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'

declare type Methods = "GET" | "OPTIONS" | "HEAD" | "POST" | "PUT" | "DELETE" | "TRACE" | "CONNECT"

declare interface Datas {
    method?: Methods

    [key: string]: any
}

const baseURL = MAINHOST
let token = getToken()

class HttpRequest {
    public queue: any // 请求的url集合
    public constructor() {
        this.queue = {}
    }

    destroy(url: string) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // hide loading
        }
    }

    interceptors(instance: any, url?: string) {
        // 请求拦截
        instance.interceptors.request.use((config: AxiosRequestConfig) => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // show loading
            }
            if (url) {
                this.queue[url] = true
            }
            return config
        }, (error: any) => {
            console.error(error)
        })
        // 响应拦截
        instance.interceptors.response.use((res: AxiosResponse) => {
            if (url) {
                this.destroy(url)
            }
            const {data, status} = res
            if (status === 200 && ISMOCK) {
                return data
            } // 如果是mock数据，直接返回
            if (status === 200 && data && data.code === 0) {
                return data
            } // 请求成功
            return requestFail(res) // 失败回调
        }, (error: any) => {
            if (url) {
                this.destroy(url)
                if (url.indexOf('getMenus') > 0) {
                    router.replace({name: 'Login'})
                } else if (url.indexOf('importExcel') > 0) {
                    alert('导入数据失败！')
                } else if (url.indexOf('uploadFile') > 0) {
                    alert('上传文件失败！')
                } else if (url.indexOf('save') > 0) {
                    alert('保存数据失败！')
                }
            }
            console.error(error)
        })
    }

    async request(options: AxiosRequestConfig) {
        const instance = axios.create()
        await this.interceptors(instance, options.url)
        return instance(options)
    }
}

// 请求失败
const requestFail = (res: AxiosResponse) => {
    let errStr = '网络繁忙！'
    // token失效重新登录
    if (res.data.code === 1000001) {
        return router.replace({name: 'login'})
    }

    return {
        err: console.error({
            code: res.data.errcode || res.data.code,
            msg: res.data.errmsg || errStr
        })
    }
}

// 合并axios参数
const conbineOptions = (_opts: any, data: Datas, method: Methods): AxiosRequestConfig => {
    let opts = _opts
    if (typeof opts === 'string') {
        //url = 'remove/{id}'，将{id}替换为实际数值
        if (opts.indexOf('{') > 0) {
            const optss = opts.split('{')
            opts = optss[0]
            const param = optss[1].substr(0, optss[1].indexOf('}'))

            opts += data[param]
        }
        opts = {url: opts}
    }

    const _data = {...commonPrams, ...opts.data, ...data}
    const options = {
        method: opts.method || data.method || method || 'GET',
        url: opts.url,
        header: {'user-token': token},
        baseURL
    }

    return options.method !== 'GET' ? Object.assign(options, {data: qs.stringify(_data)}) : Object.assign(options, {params: _data})
}

const HTTP = new HttpRequest()

/**
 * 抛出整个项目的api方法
 */
const Api = (() => {
    const apiObj: any = {}
    const requestList: any = requestConfig
    const fun = (opts: AxiosRequestConfig | string) => {
        return async (data = {}, method: Methods = "GET") => {
            token = getToken()

            if (!token && opts !== '/loginUser' && opts !== '/system/sms/sendCode' && opts !== '/system/sms/checkCode') {
                console.error('No Token')
                return router.replace({name: 'Login'})
            }
            const newOpts = conbineOptions(opts, data, method)

            const res = await HTTP.request(newOpts)
            return res
        }
    }
    Object.keys(requestConfig).forEach((key) => {
        apiObj[key] = fun(requestList[key])
    })

    return apiObj
})()

export default Api as any

